import Hero from './components/Hero';
import Projects from './components/Projects';

function App() {
  return (
    <>
      <Hero />
      <Projects />
    </>
  );
}

export default App;
